import validator from 'validator';
import FormValidator from './FormValidator';

const trans = window.trans;

export default new FormValidator([
    {
        field: 'to',
        method: validator.isEmpty,
        validWhen: false,
        message: trans.error_required_field_empty,
    },
    {
        field: 'greeting',
        method: validator.isEmpty,
        validWhen: false,
        message: trans.error_required_field_empty,
    },
    {
        field: 'greeting',
        method: validator.isLength,
        args: [{min: 0, max: 40}],
        validWhen: true,
        message: trans.error_max_length_40,
    },
    {
        field: 'phone',
        method: validator.isEmpty,
        validWhen: false,
        message: trans.error_phone_empty,
    },
    {
        field: 'email',
        method: validator.isEmail,
        validWhen: true,
        message: trans.error_email_invalid,
    },
]);


// WEBPACK FOOTER //
// ./scripts/util/validators/VoucherFormValidator.js